import { defineMessages } from "@/i18n";
import en from "./en";

export const libLabelsMessages = defineMessages("lib-labels", en);
